import store from "../../redux-store/index"

export const getUpdatedNotificationData = () => {
    return store.getState().notificationsStore.allNewOnlineOrders
}